export enum CronFrequency {
  daily = "daily",
  weekly = "weekly",
}
